import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Tooltip
} from '@mui/material';
import {
  AccessTime
} from '@mui/icons-material';

const TimeDisplay = ({ timezone = 'America/New_York' }) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    // Update time immediately
    setCurrentTime(new Date());

    // Update time every minute (60 seconds)
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  // Format time for display (12-hour format with AM/PM)
  const formatTime = (date) => {
    return new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    }).format(date);
  };

  // Format date for tooltip (full date and time)
  const formatFullDateTime = (date) => {
    return new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
      timeZoneName: 'short'
    }).format(date);
  };

  // Get timezone abbreviation (EST/EDT)
  const getTimezoneAbbr = (date) => {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      timeZoneName: 'short'
    });
    const parts = formatter.formatToParts(date);
    const timeZonePart = parts.find(part => part.type === 'timeZoneName');
    return timeZonePart ? timeZonePart.value : 'EST';
  };

  return (
    <Tooltip title={formatFullDateTime(currentTime)}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mr: 2 }}>
        <AccessTime sx={{ color: '#000062', fontSize: '1.2rem' }} />
        <Typography variant="body2" sx={{ fontWeight: 'medium', color: '#000062' }}>
          {formatTime(currentTime)}
        </Typography>
        <Typography variant="caption" sx={{ color: '#757575', fontSize: '0.7rem' }}>
          {getTimezoneAbbr(currentTime)}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default TimeDisplay; 